<template>
    <div class="wrapper">
        <h1 class="crumb">派工列表</h1>
        <div class="bar">
            <div class="btnGroup">
                <span style="margin-left: 50px;">安装日期　</span>
                <el-date-picker
                    v-model="installDate"
                    type="daterange"
                    range-separator="至"
                    @change="getInstallList"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <el-select v-model="ssgn" placeholder="请选择" style="width: 150px;margin-left: 30px">
                    <el-option
                        v-for="item in ssgnSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <span><el-input v-model="searchKey" style="width: 200px" placeholder="请输入"></el-input></span>
                <el-button class="btn" @click="getInstallList" style="">搜索</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column label="操作" align="center" width="250">
                <template slot-scope="props" >
                    <el-button type="text" style="font-size: 12px" @click="wangong(props.row)">完工</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px" @click="xiapai(props.row)">安装队</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px" @click="beizhu(props.row)">备注</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px"  @click="gaiqi(props.row)">改期</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px"  @click="qrDelete(props.row)">作废</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px"  @click="Return(props.row)">退货</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px" @click="dayin(props.row)">A4打印</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px" @click="dayin2(props.row)">A5打印</el-button><span> | </span>
                    <el-button type="text" style="font-size: 12px" @click="qrdayin(props.row)">确认已打印</el-button>
                </template>
            </el-table-column>
            <el-table-column label="提货单号" width="100" align="center">
                <template slot-scope="props">
                    <div  style="font-size: 10px;" :style="props.row.referer ==='管理员添加'?{color:'red'}:''">{{props.row.referer !=='管理员添加'?props.row.install_sn:'只安装'}}</div>
                </template>
            </el-table-column>
            <!--<el-table-column label="合同订单号" prop="contract_number" align="center"></el-table-column>-->
            <el-table-column label="销售单位" prop="referer" align="center" :formatter="XSDW"></el-table-column>
            <el-table-column label="型号" width="120" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.order_goods" style="font-size: 10px">{{item.goods_attr_select.length ===0?item.goods_attr:item.goods_attr_select[0]}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="50" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.order_goods">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="提单号" prop="tidan" align="center" ></el-table-column>
            <el-table-column label="安装码" prop="install_code" align="center" ></el-table-column>
            <el-table-column label="送货地址" prop="address_all" align="center" width="140"></el-table-column>
            <el-table-column label="收货人" prop="consignee" align="center"></el-table-column>
            <el-table-column label="联系方式" prop="mobile" align="center"></el-table-column>
            <el-table-column label="备用电话" prop="tel" align="center"></el-table-column>
            <el-table-column label="安装工程队" prop="team_name" align="center"></el-table-column>
            <el-table-column label="预约时间" prop="yuyue_time" align="center" sortable></el-table-column>
            <el-table-column label="备注" prop="remark" align="center" width="130"></el-table-column>
            <el-table-column label="公司备注" prop="company_remark" align="center"width="130"></el-table-column>
            <el-table-column label="送货方式" prop="delivery_method_name" align="center" sortable></el-table-column>
            <el-table-column label="打印状态" prop="print_status" align="center" :formatter="isprint" sortable></el-table-column>
            <!--<el-table-column label="安装单状态" prop="status_name" align="center"></el-table-column>-->
            <!--<el-table-column label="订单添加时间" prop="addtime" align="center"></el-table-column>-->
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout=" total,prev, pager, next"
            :total="total">
        </el-pagination>
        <el-dialog title="安装单改期" :visible.sync="ChangeInstallDate" width="500px">
        <el-form :model="form" style="margin-top: 30px;padding: 0 30px">
        <el-form-item label="修改日期:" :label-width="formLabelWidth">
        <el-date-picker
        v-model="change.changeDate"
        type="date"
        placeholder="选择日期">
        </el-date-picker>
        </el-form-item>
        <el-form-item label="改期原因:" :label-width="formLabelWidth">
        <el-select v-model="change.changerReson" placeholder="请选择">
        <el-option v-for="item in reasonList" :value="item.value" :key="item.value" :label="item.label"></el-option>
        </el-select>
        </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="padding: 20px 0">
        <el-button type="primary" @click="rqChangeDate">确定</el-button>
        </div>
        </el-dialog>
        <el-dialog title="退货" :visible.sync="ReturnOrder" width="500px">
            <el-form :model="forms" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="退货原因:" :label-width="formLabelWidth">
                    <el-select v-model="tuihuo.changerReson" placeholder="请选择">
                        <el-option v-for="item in tuihuoList" :value="item.value" :key="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button type="primary" @click="rqReturn">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="备注" :visible.sync="Beizhu" width="500px">
            <el-form :model="forms" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="备注:" :label-width="formLabelWidth">
                    <el-input v-model="company_remark" style="width: 60%;float: left"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button  @click="Beizhu = false">取消</el-button>
                <el-button type="primary" @click="qrBeizhu">确定</el-button>
            </div>
        </el-dialog>
        <!--下派安装队-->
        <el-dialog :visible.sync="dialogXiapai"
                   title="更改安装队">
            <el-form ref="form" :rules="rules" :model="formData" style="padding: 30px" >
                <el-form-item label="安装队名称：" prop="company_name" label-width="100" style="text-align: left">
                    <el-select v-model="formData.team_id" placeholder="安装队名称" @change="selectname(formData.team_id)">
                        <el-option v-for="item in selectList" :label="item.team_name" :value="item.team_id" :key="item.team_id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogXiapai = false">取 消</el-button>
                <el-button type="primary" @click="queren">确 定</el-button>
            </span>
        </el-dialog>
        <!--完工-->
        <el-dialog title="完工提交" :visible.sync="Finish" width="500px">
            <el-form :model="forms" style="margin-top: 30px;padding: 0 30px;text-align: left">
                <el-form-item label="上传图片:" :label-width="formLabelWidth">
                    <el-upload
                        class="upload-demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :on-remove='removepz1'
                        :http-request='upImgs1'
                        :on-exceed="handleExceed1"
                        :before-upload="beforeAvatarUpload1"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="提单号:" :label-width="formLabelWidth">
                    <el-input v-model="tidan" style="width: 70%"></el-input>
                </el-form-item>
                <el-form-item label="安装码:" :label-width="formLabelWidth">
                    <el-input v-model="install_code" style="width: 70%"></el-input>
                </el-form-item>
                <el-form-item>
                    <div v-for="(item,index) in feiyongList" style="margin-top: 10px">
                        <el-autocomplete
                            class="inline-input"
                            v-model="feiyongList[index].name"
                            :fetch-suggestions="querySearch"
                            placeholder="请输入内容"
                            @select="handleSelect(item,index)"
                            style="float: left;width: 40%"
                        ></el-autocomplete>
                        <el-input type="text" v-model="feiyongList[index].price" style="width: 40%;margin-left: 20px"></el-input>
                        <el-button type="text" @click="deleteFeiyong(index)">删除</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div style="text-align: center">
                <el-button type="primary" @click="addFeiyong">添加费用</el-button>
            </div>

            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button  @click="Finish = false">取消</el-button>
                <el-button type="primary" @click="qrFinish">确认完工</el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
    import {getInstallList, getInsTeamList, ChargeCompany, XiapaiAzd} from '../stores/api'
    import qs from 'qs'
    export default {
        data() {
            return {
                dialogXiapai: false,
                Finish: false,
                Beizhu: false,
                page: 1,
                company_remark: '',
                bzId: '',
                page_count: 1,
                total: '',
                ssgnSelect: [{name: '收货人电话', referer: 'mobile'}, {name: '安装队名', referer: 'team_name'}, {name: '提货单号', referer: 'contract_number'}, {name: '规格型号', referer: 'goods_attr'}],
                ssgn: 'mobile',
                searchKey: '', //关键字搜索
                installDate: '', //安装日期搜索
                tableData: [],
                selectList: [],
                formData: {
                    // session_id: localStorage.getItem('session_id'),
                    // act: 'paidan',
                    team_id: '',
                    team_name: '',
                    install_id: '',
                    // session_id: localStorage.getItem('session_id'),
                },
                form: '',
                forms: '',
                ChangeInstallDate: false, //改期
                reasonList: [{value: '客户没时间', label: '客户没时间'}, {value: '装修未完成',label: '装修未完成'}, {value: '其它', label: '其它'}],
                change: {
                    changeDate: '',
                    changerReson: '',
                },
                ReturnOrder: false, //退货
                tuihuoList: [{value: '安装位置不够空间', label: '安装位置不够空间'}, {value: '匹数不对', label: '匹数不对'}, {value: '客户无理由退货', label: '客户无理由退货'}, {value: '更换颜色', label: '更换颜色'}, {value: '其它', label: '其它'}],
                tuihuo: {
                    tuihuoReson: '',
                },
                //上传图片
                limit: 3, //限制三张根图片
                formData1: [],
                baseImg1: '',
                install_id: '',
                install_code: '',
                tidan: '',
                feiyongList: [{name: '', price: 0}],
                restaurants: [{value: '远程费', name: 'fee_yuancheng'}, {value: '拆装机费', name: 'fee_chaizhuang'}, {value: '高空费', name: 'fee_gaokong'}, {value: '支架费', name: 'fee_zhijia'}, {value: '铜管费', name: 'fee_gangguan'}, {value: '难度费', name: 'fee_nandu'}],
            }
        },
        filters: {
        },
        created() {
            this.getInstallList()
        },
        methods: {
            isprint(row, clumn) {
                if (row.print_status === '1') {
                    return '已打印'
                } else {
                    return '未打印'
                }
            },
            XSDW(row) {  //格式化销售单位
                let name = ''
                if (row.referer === 'k3导入') {
                    name = row.store_name
                } else if (row.referer === '门店') {
                    name = row.store_name
                } else if (row.referer === '') {
                    name = ''
                } else {
                    name = row.store_name
                }
                return name
            },
            handleCurrentChange (val) {
                this.page = val
                this.getInstallList()
            },
            getInstallList() {
                let temp = {}
                temp.page = this.page
                temp.state = 25
                if (this.installDate) {
                    console.log(this.installDate)
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10)
                }
                if (this.searchKey !== '') {
                    if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'team_name') {
                        temp.team_name = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    }
                }
                getInstallList(temp).then(res => {
                    console.log(res.data.install_list)
                    this.tableData = res.data.install_list
                    this.total = res.data.count
                    if (this.tableData) {
                        this.tableData.forEach((item, i) => {
                            this.tableData[i]['addr'] = item.province + item.city + item.district + item.address
                        })
                    }
                })
            },

            gaiqi (row) {
                this.form = row
                this.ChangeInstallDate = true
            },
            //备注
            beizhu(row) {
              this.Beizhu = true
                this.company_remark = row.company_remark
                this.bzId = row.install_id
            },
            qrBeizhu() {
              this.$http.post(this.$reqUrl + `service.php?act=company_remark_install&session_id=${localStorage.getItem('azgs_session_id')}&install_id=${this.bzId}&company_remark=${this.company_remark}`).then(res => {
                  if (res.data.error === 0) {
                      this.$message.success('添加备注成功')
                      this.getInstallList()
                      this.Beizhu = false
                  } else {
                      this.$message.error('添加失败')
                  }
              })
            },
            //改期
            rqChangeDate () {
                let gaiqiDate = Date.parse(this.change.changeDate.toLocaleDateString()).toString().slice(0, 10)
                this.$http.post(this.$reqUrl + `service.php?act=change_time&session_id=${localStorage.getItem('azgs_session_id')}&install_id=${this.form.install_id}&yuyue_time=${gaiqiDate}&change_time_reason=${this.change.changerReson}`).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.getInstallList()
                        this.ChangeInstallDate = false
                    }
                })
            },
            Return (row) { //退货
                this.ReturnOrder = true
                this.forms = row
            },
            dayin(row) {
                localStorage.setItem('installData', JSON.stringify(row))
                let routeData = this.$router.resolve({
                    name: "Printing",
                });
                window.open(routeData.href, '_blank');
                // this.$router.push({path: '/Printing'})
            },
            dayin2(row) {
                localStorage.setItem('installData', JSON.stringify(row))
                let routeData = this.$router.resolve({
                    name: "Printing1",
                });
                window.open(routeData.href, '_blank');
                // this.$router.push({path: '/Printing1'})
            },
            rqReturn () {
                this.$http.post(this.$reqUrl + `service.php?act=return&session_id=${localStorage.getItem('azgs_session_id')}&install_id=${this.forms.install_id}&return_reason=${this.tuihuo.tuihuoReson}`).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.getInstallList()
                        this.ReturnOrder = false
                    }
                })
            },
            qrDelete (row) {
                this.$alert('确定作废该安装单?', '安装单作废', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    // callback: action => {
                    // }
                }).then(() => {
                    this.$http.get(this.$reqUrl + `service.php?act=team_cancel&session_id=${localStorage.getItem('azgs_session_id')}&install_id=${row.install_id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                            this.getInstallList()
                        }
                    })
                }).catch(() => {
                    console.log('请求失败')
                })
            },
            //确认打印
            qrdayin (row) {
                this.$alert('确定修改打印状态为已打印?', '更改打印状态', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(this.$reqUrl + `service.php?act=printed&session_id=${localStorage.getItem('azgs_session_id')}&install_id=${row.install_id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                            this.getInstallList()
                        }
                    })
                }).catch(() => {
                    console.log('请求失败')
                })
            },
            //完工提交
            wangong (row) {
              this.Finish = true
                this.install_id = row.install_id
                this.formData1 = []
                this.feiyongList = [{name: '', price: 0}]
            },
            upImgs1(item) {
                let self = this;
                var file = item.file
                var reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = function(e) {
                    self.baseImg1=this.result
                    self.formData1.push( self.baseImg1);
                    // console.log(self.formData1);
                    self.wangong.image1=self.formData1[0]
                }
            },
            handleExceed1() {
                this.$error.message('只能选择三张图片')
            },
            beforeAvatarUpload1(file) {
                if (!/image\/\w+/.test(file.type)) {
                   this.$message.error('只能上传图片')
                    return false
                }
            },
            //移除凭证钩子
            removepz1(val){
                Array.prototype.remove = function (val) {
                    var index = this.indexOf(val);
                    if (index > -1) {
                        this.splice(index, 1);
                    }
                };
                var file = val.raw
                var reader = new FileReader()
                reader.readAsDataURL(file)
                let self = this;
                reader.onload = function(e) {
                    self.formData1.remove(this.result);
                    self.wangong.image1 = ''
                }
            },
            //添加费用
            addFeiyong() {
              let data = {name: '', price: 0}
              this.feiyongList.push(data)
                console.log(this.feiyongList)
            },
            //删除费用
            deleteFeiyong(index) {
                if (this.feiyongList.length > 1) {
                    this.feiyongList.splice(index, 1)
                } else {
                    // this.$message.error('')
                }
            },
            //确认完工
            qrFinish () {
                console.log(this.formData1)
                let image1 = ''
                let image2 = ''
                let image3 = ''
                if (this.formData1[0]) {
                    image1 = this.formData1[0]
                } else {
                    image1 = ''
                }
                if (this.formData1[1]) {
                    image2 = this.formData1[1]
                } else {
                    image2 = ''
                }
                if (this.formData1[2]) {
                    image3 = this.formData1[2]
                } else {
                    image3 = ''
                }
                let wangong = {
                    // image1: image1,
                    // image2: image2,
                    // image3: image3,
                    images:this.formData1,
                    install_id: this.install_id, //安装单id
                    install_code: this.install_code,
                    tidan: this.tidan,
                    fee_other: [],
                }
                this.feiyongList.forEach(item => {
                    if (item.name !== '') {
                        wangong.fee_other.push({name: item.name, price: item.price})
                    }
                    // if (item.name === '远程费') {
                    //     wangong.fee_yuancheng = item.price
                    // } else if (item.name === '拆装机费') {
                    //     wangong.fee_chaizhuang = item.price
                    // } else if (item.name === '高空飞') {
                    //     wangong.fee_gaokong = item.price
                    // } else if (item.name === '支架费') {
                    //     wangong.fee_zhijia = item.price
                    // } else if (item.name === '铜管费') {
                    //     wangong.fee_gangguan = item.price
                    // } else if (item.name === '难度费') {
                    //     wangong.fee_nandu = item.price
                    // } else {
                    //     let n = item.name
                    //     wangong[n] = item.price
                    // }
                })
                // console.log(wangong);
                this.$http.post(this.$reqUrl + `service.php?act=confirm_done&session_id=${localStorage.getItem('azgs_session_id')}`,qs.stringify(wangong)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.Finish = false
                        this.getInstallList()
                    }
                })
            },
            //下派
            xiapai(row, val) {
                console.log(row)
                let install_id = row.install_id
                this.formData.install_id = install_id
                this.page = 1;
                getInsTeamList(this.page).then(res => {
                    console.log(res.data)
                    this.selectList = []
                    this.selectList = res.data.team_list
                    this.page_count = res.data.page_count
                    if (this.page_count > 1) {
                        this.page = 2;
                        for (var i = 0; i < this.page_count - 1; i++) {
                            this.page += i;
                            getInsTeamList(this.page).then(res => {
                                res.data.team_list.forEach(item => {
                                    this.selectList.push(item)
                                })
                            })
                        }
                    }
                })
                console.log(this.selectList)
                this.dialogXiapai = true
            },
            selectname(id) {
                this.selectList.forEach((item, i) => {
                    if (id === item.team_id) {
                        this.formData.team_name = item.team_name
                    }
                })
                console.log(this.formData)
            },
            queren() {
                if (this.formData.team_name === '') {
                    this.$message.error('请选择下派安装队')
                } else {
                    this.$http.get(this.$reqUrl + `service.php?session_id=${localStorage.getItem('azgs_session_id')}&act=paidan&team_id=${this.formData.team_id}&team_name=${this.formData.team_name}&install_id=${this.formData.install_id}`).then(res=>{
                        console.log(res)
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                            this.dialogXiapai = false
                            this.getInstallList()
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                    })
                    // XiapaiAzd(this.formData).then(res => {
                    //     console.log(res.data.error)
                    //     if (res.data.error === 0) {
                    //         this.$message.success(res.data.msg)
                    //         this.dialogXiapai = false
                    //     } else if (res.data.error === 1) {
                    //         this.$message.error(res.data.msg)
                    //     }
                    // })
                }
            },

            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(val, index) {
                console.log(val)
            }
        },
        mounted() {

        }
    }
</script>
<style lang="less" scoped>
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            button {
                width: 100Px;
                height: 37Px;
                margin-right: 10Px;
                font-size: 16px;
                color: #ffffff;
                background: #f56c31;
                border-radius: 2px;
            }
        }
    }
    .el-table th>.cell{
        color:#ea6625;
    }
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

</style>
<style>
    .el-table th>.cell{
        color:#ea6625;
    }
</style>



// WEBPACK FOOTER //
// src/router/PaigongLists.vue